import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import moment from "moment";
import { showDevTools } from "./env";

moment.locale("de");

library.add(fas);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(Buefy, {
  defaultIconComponent: FontAwesomeIcon,
  defaultIconPack: "fas"
});

Vue.config.productionTip = false;
Vue.config.devtools = showDevTools || false;

Vue.filter("formatDate", function(value) {
  if (value) {
    return moment(String(value)).format("DD.MM.YYYY");
  }
});
Vue.filter("formatDateTime", function(value) {
  if (value) {
    return moment(String(value)).format("DD.MM.YYYY, kk:mm") + " Uhr";
  }
});
Vue.filter("formatRelative", function(value) {
  if (value) {
    return moment(String(value)).fromNow();
  }
});
Vue.filter("timeSince", function(value) {
  if (value) {
    return value.replace("vor", "seit");
  }
});
Vue.filter("pricing", function(value) {
  if (value) {
    return new Intl.NumberFormat("de-DE", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 5,
      maximumFractionDigits: 5
    }).format(value);
  }
});
Vue.filter("gigabytes", function(value) {
  if (value) {
    return (parseFloat(value).toFixed(2) + " GB").replace(".", ",");
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
